<template lang="">
  <div class="content">
    <div id="imageList" v-if="list.length > 0" class="tops flex">
      <swiper :options="swiperOption" class="imgcasesT" ref="mySwipers">
        <swiper-slide
          v-for="(it, index) in list"
          :key="index"
          class="swiper-slides"
        >
          <div class="cubeBox">
            <div class="img-item">
              <div class="imgBox">
                <img :src="it.imgPath" @click="previewClick(index)" />
                <!-- <p>{{ it.name }}</p> -->
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="swiper-button-prev" @click="prevs()"></div>
    <div class="swiper-button-next" @click="nexts()"></div>

    <image-preview2
      :show.sync="imgpre"
      :list="imglist"
      :initialIndex="initialIndex"
    ></image-preview2>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
// import { getIndustrialDistribution } from "@/api/cyzl";
const imagePreview2 = () => import("@/components/imagePreview2");
export default {
  components: { Swiper, SwiperSlide, imagePreview2 },
  data() {
    return {
      swiperOption: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        debugger: true,
        autoplayDisableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        autoplay: {
          // loop: true,
          delay: 5000
        },
        loop: true,
        // autoplay: 5000,
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        centeredSlides: true, //<span style="color:rgb(68,68,68);font-family:'microsoft yahei';font-size:13px;">设定为true时，活动块会居中，而不是默认状态下的居左。</span>
        prevButton: ".swiper-button-prev", //上一张
        nextButton: ".swiper-button-next", //下一张
        notNextTick: true,
        pagination: ".swiper-pagination",
        speed: 300,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      list: [
        {
          name: "世界荔枝种植分布",
          imgPath: process.env.VUE_APP_PUBLIC_PATH + "/img/world_fb_new.png"
        },
        {
          name: "中国荔枝种植分布",
          imgPath: process.env.VUE_APP_PUBLIC_PATH + "/img/china_fb_new2.png"
        },
        {
          name: "广东荔枝种植分布",
          imgPath: process.env.VUE_APP_PUBLIC_PATH + "/img/gd_fb_new3.png"
        },
        {
          name: "茂名荔枝种植分布",
          imgPath: process.env.VUE_APP_PUBLIC_PATH + "/img/mm_fb_new3.jpg"
        }
      ],
      imgpre: false,
      initialIndex: 0,
      imglist: []
    };
  },
  mounted() {
    this.imglist = this.list.map(ele => {
      return ele.imgPath;
    });
  },
  methods: {
    swiperChange() {
      console.log(this.$refs.mySwipers.$swiper.activeIndex);
    },
    prevs() {
      this.$refs.mySwipers.$swiper.slidePrev();
      console.log(
        this.$refs.mySwipers.$swiper,
        "----swiper-",
        this.$refs.mySwipers
      );
    },
    nexts() {
      this.$refs.mySwipers.$swiper.slideNext();
    },
    previewClick(index) {
      // if (index > 5) {
      //   index = index - 5;
      // }
      this.initialIndex = index;
      this.imgpre = true;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'

.content
  height 100%
  position relative
  padding 0.09rem 0 0.07rem 0
  box-sizing border-box
.tops
  position relative
  height 100%
  width 92%
  margin 0 4%
  overflow hidden
  z-index 9
.imgcasesT
  width 100%
  position relative
  overflow initial
  margin 0
  height 100%
  z-index 5
.swiper-slides
  display flex
  align-content center
  justify-content center
  flex-direction column
  z-index 9
.swiper-button-prev, .swiper-button-next
  width 16px
  height 23px
  top 55%
.swiper-button-prev
  background url('~images/index/szjc/left.png') center no-repeat
  background-size 100% 100%
  left 20px
.swiper-button-next
  background url('~images/index/szjc/right.png') center no-repeat
  background-size 100% 100%
  right 20px
.cubeBox
  height 100%
  color #fff
  position relative
  // background url('~images/index/cyld/ldjs_bg.png') center no-repeat
  background-size 100% 100%
  width calc(100% - 0.06rem)
  margin 0 0.03rem
  .img-item
    width 100%
    height 100%
    text-align center
    .imgBox
      width 100%
      height 100%
      display flex
      justify-content center
      align-items flex-start
      position relative
      // margin 0 auto
      >img
        // width 100%
        height 100%
        // margin 0 auto
        cursor pointer
      >p
        width 70px
        margin-left 10px
        margin-top 5px
      // >p
      //   position absolute
      //   left 0
      //   right 0
      //   bottom 0
      //   height 22px
      //   line-height 22px
      //   background rgba(0,0,0,.4)
      //   color #fff
</style>
